import { render, staticRenderFns } from "./IconMyBooking.vue?vue&type=template&id=0336e012&"
import script from "./IconMyBooking.vue?vue&type=script&lang=js&"
export * from "./IconMyBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports